<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 20.0002H18C18.55 20.0002 19 20.4502 19 21.0002C19 21.5502 18.55 22.0002 18 22.0002H6C5.45 22.0002 5 21.5502 5 21.0002C5 20.4502 5.45 20.0002 6 20.0002ZM12 7.00018C10.9 7.00018 10 7.90018 10 9.00018C10 10.1002 10.9 11.0002 12 11.0002C12.5304 11.0002 13.0391 10.7895 13.4142 10.4144C13.7893 10.0393 14 9.53062 14 9.00018C14 8.46975 13.7893 7.96104 13.4142 7.58597C13.0391 7.2109 12.5304 7.00018 12 7.00018ZM12 2.00018C15.27 2.00018 19 4.46018 19 9.15018C19 12.1302 16.87 15.2702 12.61 18.5402C12.25 18.8202 11.75 18.8202 11.39 18.5402C7.13 15.2602 5 12.1302 5 9.15018C5 4.46018 8.73 2.00018 12 2.00018Z"
  />
</template>
